module.exports = __webpack_public_path__ + "img/cb.6015649b.jpg";